export enum OrderTransitionError {
  USER_NOT_CONNECTED = 'USER_NOT_CONNECTED',
  INSUFFICIENT_STOCK_ERROR = 'INSUFFICIENT_STOCK_ERROR',
  SHIPPING_FORM_MISSING_FIELD_EMAIL = 'SHIPPING_FORM_MISSING_EMAIL_ADDRESS',
  SHIPPING_FORM_MISSING_FIELD_FIRST_NAME = 'SHIPPING_FORM_MISSING_FIELD_FIRST_NAME',
  SHIPPING_FORM_MISSING_FIELD_LAST_NAME = 'SHIPPING_FORM_MISSING_FIELD_LAST_NAME',
  SHIPPING_FORM_MISSING_FIELD_ADDRESS = 'SHIPPING_FORM_MISSING_FIELD_ADDRESS',
  SHIPPING_FORM_MISSING_FIELD_ZIP_CODE = 'SHIPPING_FORM_MISSING_FIELD_ZIP_CODE',
  SHIPPING_FORM_MISSING_FIELD_CITY = 'SHIPPING_FORM_MISSING_FIELD_CITY',
  SHIPPING_FORM_MISSING_FIELD_COUNTRY_CODE = 'SHIPPING_FORM_MISSING_FIELD_COUNTRY_CODE',
  SHIPPING_FORM_MISSING_FIELD_PROVINCE = 'SHIPPING_FORM_MISSING_FIELD_PROVINCE',
  SHIPPING_FORM_INVALID_FIELD_PROVINCE = 'SHIPPING_FORM_INVALID_FIELD_PROVINCE',
  SHIPPING_FORM_INVALID_FIELD_ZIP_CODE = 'SHIPPING_FORM_INVALID_FIELD_ZIP_CODE',
  SHIPPING_FORM_INVALID_FIELD_EMAIL = 'SHIPPING_FORM_INVALID_FIELD_EMAIL',
  BILLING_FORM_MISSING_FIELD_EMAIL = 'BILLING_FORM_MISSING_EMAIL_ADDRESS',
  BILLING_FORM_MISSING_FIELD_FIRST_NAME = 'BILLING_FORM_MISSING_FIELD_FIRST_NAME',
  BILLING_FORM_MISSING_FIELD_LAST_NAME = 'BILLING_FORM_MISSING_FIELD_LAST_NAME',
  BILLING_FORM_MISSING_FIELD_ADDRESS = 'BILLING_FORM_MISSING_FIELD_ADDRESS',
  BILLING_FORM_MISSING_FIELD_ZIP_CODE = 'BILLING_FORM_MISSING_FIELD_ZIP_CODE',
  BILLING_FORM_MISSING_FIELD_CITY = 'BILLING_FORM_MISSING_FIELD_CITY',
  BILLING_FORM_MISSING_FIELD_COUNTRY_CODE = 'BILLING_FORM_MISSING_FIELD_COUNTRY_CODE',
  BILLING_FORM_MISSING_FIELD_PROVINCE = 'BILLING_FORM_MISSING_FIELD_PROVINCE',
  BILLING_FORM_INVALID_FIELD_PROVINCE = 'BILLING_FORM_INVALID_FIELD_PROVINCE',
  BILLING_FORM_INVALID_FIELD_ZIP_CODE = 'BILLING_FORM_INVALID_FIELD_ZIP_CODE',
  BILLING_FORM_INVALID_FIELD_EMAIL = 'BILLING_FORM_INVALID_FIELD_EMAIL',
}

export enum OrderValidationError {
  INVALID_EMAIL_IN_ADDRESS = 'INVALID_EMAIL_IN_ADDRESS',
}

export enum VertexTaxError {
  VERTEX_TAX_ERROR = 'VERTEX_TAX_ERROR',
}
